<script lang="ts" setup name="BaseCardNotAvailable">
import BaseCardState from '~/components/BaseCardState.vue';

import type { IllustrationType } from '~/types';

const {
  title,
  illustration = 'no-data',
  message,
  styled,
} = defineProps<{
  title?: string;
  message?: string;
  illustration?: IllustrationType;
  styled?: boolean;
}>();
</script>

<template>
  <BaseCardState
    spacing="card-lg"
    :title="title"
    :message="message"
    :illustration="illustration"
    :styled="styled"
  />
</template>
